import { render } from "./PhysicianOrderCard.vue?vue&type=template&id=54e67341&ts=true"
import script from "./PhysicianOrderCard.ts?vue&type=script&lang=ts&external"
export * from "./PhysicianOrderCard.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__